import {Component, ChangeDetectionStrategy} from '@angular/core';
@Component({
    selector: 'ctv-loader',
    template: `
    <div class="cm-global-spinner-background">
      <div class="cm-global-spinner">
        <mat-spinner [color]="'primary'" [mode]="'indeterminate'"></mat-spinner>
      </div>
    </div>`,
    styleUrls: ['./global-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlobalSpinnerComponent {

}
